import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Icon from 'components/DesignSystem/Icon';
import { PreferenceList } from 'services/api/Meteorology';
import dateDiffToDate from 'helper/dateDiffToDate';
import useNumericForecastControlPanel from 'utils/hooks/meteorology/useNumericForecastControlPanel';
import { requestConsult, setViewMode } from 'redux/reducers/meteorologyFieldsControlPanelReducer';
import { cssVar } from 'constants/theme';
import './index.scss';

export default function Preference({ preference, onDelete, deleteLoading }: {
  preference: PreferenceList,
  onDelete: ({ id }: { id: number }) => void,
  deleteLoading: boolean,
}) {
  const dispatch = useDispatch();
  const {
    setPeriod,
    setModelArray,
    setVariable,
    setRegion,
    setForecastUnixDate,
    setAnomaly,
    resetPreferences,
  } = useNumericForecastControlPanel();
  const onDeleteClick = () => {
    onDelete({ id: preference.id });
  };
  const deleteButtonIcon = deleteLoading ? (
    <Spinner size="sm" />
  ) : (
    <Icon iconType="trash" color={cssVar('text-strong')} />
  );

  const loadPreference = () => {
    const today = new Date();
    const date = dateDiffToDate(preference.json.data_prev, [today]) || today;
    // Preferências salvas antes do Heatmap não têm tipo_visualizacao → 'spatial'.
    const viewMode = preference.json.tipo_visualizacao ?? 'spatial';

    resetPreferences();
    setPeriod(preference.json.periodo_interesse);
    setVariable(preference.json.variavel_meteorologica);
    setModelArray(preference.json.modelos);
    setRegion(preference.json.area_plotagem);
    setForecastUnixDate(date);
    setAnomaly(preference.json.anom);
    dispatch(setViewMode(viewMode));

    // Dispara a consulta automaticamente quando a preferência tem os filtros
    // mínimos necessários — assim o usuário não precisa clicar em "Realizar consulta".
    const hasModels = (preference.json.modelos ?? []).length > 0;
    const canQuery = viewMode === 'heatmap'
      ? Boolean(preference.json.variavel_meteorologica && hasModels)
      : Boolean(
        preference.json.area_plotagem && hasModels && preference.json.periodo_interesse,
      );
    if (canQuery) {
      dispatch(requestConsult());
    }
  };

  return (
    <div className="d-flex flex-row align-items-center">
      <Button
        variant="link"
        onClick={loadPreference}
        className="btn-control-panel flex-grow-1"
      >
        { preference.name }
      </Button>
      <Button
        className="btn-preference p-0 ratio-1x1 icon-container"
        onClick={onDeleteClick}
        disabled={deleteLoading}
      >
        {deleteButtonIcon}
      </Button>
    </div>
  );
}
